import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e6ab6e6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  key: 0,
  class: "button-container"
};
const _hoisted_8 = {
  class: "selected-actuator-list"
};
const _hoisted_9 = {
  class: "dialog-footer"
};
const _hoisted_10 = {
  class: "selected-actuator-list"
};
const _hoisted_11 = {
  class: "dialog-footer"
};
import { ref, unref, reactive, onMounted, watch, computed } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import { listPage, startTest, joinOrExitTest, runningTaskPageAll } from "@/api/deviceManage";
import { weChatrequest } from '@/utils/request';
export default {
  __name: 'list-old',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const form = ref(null);
    const startTestFormRef = ref(null);
    const joinTestFormRef = ref(null);
    const route = useRoute();
    const router = useRouter();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '测试管理';
    });
    const formatCode = function (code, column) {
      if (code == 1) {
        return '正常';
      } else if (code == 2) {
        return '告警';
      } else if (code == 3) {
        return '离线';
      } else {
        return '离线';
      }
    };
    const formatTesting = function (testing, column) {
      return testing ? '测试中' : '-';
    };
    const state = reactive({
      code: '',
      loading: false,
      multiple: true,
      testLoading: false,
      testLoading1: false,
      testLoading2: false,
      testLoading3: false,
      ids: [],
      testIds: [],
      startTestDialogVisible: false,
      selectedActuatorList: [],
      startTestForm: {
        taskName: '',
        taskIntervalMinutes: 30,
        planEndTime: '',
        remark: ''
      },
      startTestRules: {
        taskName: [{
          required: true,
          message: '请输入测试名称',
          trigger: 'blur'
        }],
        taskIntervalMinutes: [
        // { required: true, message: '请输入测试频率', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === '') {
              callback(new Error('请输入测试频率'));
            } else if (value < 5) {
              callback(new Error('测试频率不能小于5分钟'));
            } else if (value > 1440) {
              callback(new Error('测试频率不能大于1440分钟'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        planEndTime: [
        // { required: true, message: '请选择计划结束时间', trigger: 'change' },
        {
          validator: (rule, value, callback) => {
            if (value && new Date(value).getTime() <= Date.now()) {
              callback(new Error('计划结束时间必须大于当前时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      },
      // 加入测试相关
      joinTestDialogVisible: false,
      joinSelectedActuatorList: [],
      joinTestForm: {
        testId: ''
      },
      joinTestRules: {
        testId: [{
          required: true,
          message: '请选择测试任务',
          trigger: 'change'
        }]
      },
      // 测试记录列表
      testList: [],
      testListLoading: false,
      tableData: {
        rows: [],
        total: 0
      },
      queryParams: {
        pageSize: 15,
        pageNum: 1,
        actNum: "",
        actStatus: "",
        valveName: "",
        valveCode: "",
        order: "",
        prop: "",
        areaId: ''
      },
      actNum: null,
      point: null,
      formUpgrade: {
        fmSize: "",
        fmCrc: ""
      },
      tableHeader: [{
        prop: "valveName",
        label: "阀井名称"
      }, {
        prop: "valveCode",
        label: "阀井编号"
      }, {
        prop: "actNum",
        label: "执行器编号"
      }, {
        prop: "location",
        label: "阀门安装位置"
      }, {
        prop: "valueInstallTime",
        label: "阀门安装日期"
      }, {
        prop: "actFwVersion",
        label: "固件版本"
      },
      // {
      //  prop: "latitude",
      //  label: "纬度",
      // },
      // {
      //  prop: "longitude",
      //  label: "经度",
      // },
      {
        prop: "actStatus",
        label: "设备状态",
        formatData: formatCode,
        type: function (row) {
          if (row.actStatus == 3) {
            return 'error';
          } else if (row.actStatus == 1) {
            return 'success';
          } else if (row.actStatus == 2) {
            return 'warning';
          } else {
            return 'error';
          }
        }
      }, {
        prop: "testing",
        label: "测试状态",
        formatData: formatTesting,
        type: function (row) {
          return row.testing ? 'warning' : 'info';
        }
      }
      // {
      //   prop: "batLevel",
      //   label: "电池电量",
      //   sort: true,
      // },
      // {
      //   prop: "bottlePressure",
      //   label: "气瓶压力",
      //   sort: true,
      // },
      ],
      searchFormData: [{
        prop: "valveName",
        label: "阀井名称",
        placeholder: "请输入阀井名称",
        type: "text",
        span: 4
      }, {
        prop: "valveCode",
        label: "阀井编号",
        placeholder: "请输入阀井编号",
        type: "text",
        span: 4
      }, {
        prop: "actNum",
        label: "执行器编号",
        placeholder: "请输入执行器编号",
        type: "text",
        span: 4
      }, {
        prop: "actStatus",
        label: "设备状态",
        placeholder: "请选择设备状态",
        filterable: true,
        type: "list",
        isSelect: false,
        options: [{
          dictValue: 1,
          dictLabel: "正常"
        }, {
          dictValue: 2,
          dictLabel: "告警"
        }, {
          dictValue: 3,
          dictLabel: "离线"
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        span: 24
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "开始测试",
        buttonStyle: "primary",
        className: 'ceshiBtn1',
        buttonIcon: "VideoPlay",
        hasPermi: ["device:page:startTest"],
        exp: () => handleStart(),
        loadingHandle(row) {
          return state.testLoading;
        }
      }, {
        buttonName: "加入测试",
        buttonStyle: "primary",
        className: 'ceshiBtn3',
        buttonIcon: "CirclePlus",
        hasPermi: ["device:page:addTest"],
        exp: () => handleStart1()
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "Search",
        class: "btn-liquid",
        handle: () => getList()
      }, {
        label: "重置",
        icon: "Refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }]
    });
    const statusOptions2 = ref([]);
    state.cloneForm = {
      ...state.form
    };
    onMounted(() => {
      // 获取地区下拉
      weChatrequest({
        url: '/api/v1/sysArea/findTree',
        method: "get"
      }).then(res => {
        statusOptions2.value = [res.data];
      });
    });
    // 测试
    const handleStart = () => {
      if (!state.ids.length) {
        ElMessage.closeAll();
        ElMessage.warning("请至少选择一个设备！");
        return;
      }
      // 根据选中的 ids 获取对应的执行器列表数据
      state.selectedActuatorList = state.tableData.rows.filter(row => state.ids.includes(row.id));

      // 重置表单
      state.startTestForm = {
        taskName: '',
        taskIntervalMinutes: 30,
        planEndTime: '',
        remark: ''
      };

      // 显示弹窗
      state.startTestDialogVisible = true;

      // 等待 DOM 更新后清除表单验证
      setTimeout(() => {
        if (startTestFormRef.value) {
          startTestFormRef.value.clearValidate();
        }
      }, 100);
    };

    // 确认开始测试
    const handleConfirmStartTest = () => {
      if (!startTestFormRef.value) return;
      startTestFormRef.value.validate(valid => {
        if (!valid) {
          return false;
        }
        const testIds = state.ids;
        state.testIds = testIds;

        // 构建接口参数
        const params = {
          idList: testIds,
          taskName: state.startTestForm.taskName,
          taskIntervalMinutes: state.startTestForm.taskIntervalMinutes,
          planEndTime: state.startTestForm.planEndTime,
          remark: state.startTestForm.remark || ''
        };
        state.testLoading = true;
        startTest(params).then(res => {
          state.testLoading = false;
          state.startTestDialogVisible = false;
          ElMessage.success("开始测试成功");
          // 刷新列表
          getList();
        }).catch(function () {
          state.testLoading = false;
        });
      });
    };
    // 获取测试记录列表
    const getTestList = () => {
      state.testListLoading = true;
      runningTaskPageAll().then(res => {
        state.testList = res.data || [];
        state.testListLoading = false;
      }).catch(() => {
        state.testListLoading = false;
      });
    };
    const handleStart1 = () => {
      if (!state.ids.length) {
        ElMessage.closeAll();
        ElMessage.warning("请至少选择一个设备加入测试！");
        return;
      }

      // 根据选中的 ids 获取对应的执行器列表数据
      state.joinSelectedActuatorList = state.tableData.rows.filter(row => state.ids.includes(row.id));

      // 重置表单
      state.joinTestForm = {
        testId: ''
      };

      // 获取测试记录列表
      getTestList();

      // 显示弹窗
      state.joinTestDialogVisible = true;

      // 等待 DOM 更新后清除表单验证
      setTimeout(() => {
        if (joinTestFormRef.value) {
          joinTestFormRef.value.clearValidate();
        }
      }, 100);
    };

    // 确认加入测试
    const handleConfirmJoinTest = () => {
      if (!joinTestFormRef.value) return;
      joinTestFormRef.value.validate(valid => {
        if (!valid) {
          return false;
        }
        const addIds = state.ids;
        state.testLoading2 = true;
        joinOrExitTest({
          "actIdList": addIds,
          "testStatus": 1,
          "testId": state.joinTestForm.testId
        }).then(res => {
          state.testLoading2 = false;
          state.joinTestDialogVisible = false;
          if (res.code == 0) {
            ElMessage.success("加入测试成功");
            // 刷新列表
            getList();
          } else {
            ElMessage.error(res.message || "加入测试失败");
          }
        }).catch(() => {
          state.testLoading2 = false;
        });
      });
    };

    /** 重置按钮操作 */
    const resetQuery = function () {
      state.queryParams.pageNum = 1;
      state.queryParams.actNum = "", state.queryParams.valveName = "";
      state.queryParams.valveCode = "";
      state.queryParams.actStatus = "";
      state.queryParams.order = "";
      state.queryParams.prop = "";
      getList();
    };
    watch(() => props.id, val => {
      state.queryParams.areaId = props.id;
      getList();
    });
    // ,{immediate:true}

    watch(() => route.query, (newQuery, oldQuery) => {
      if (!newQuery.fromRunData) {
        console.log('newQuery.fromRunData');
        resetQuery();
      }
    }, {
      immediate: true
    });
    // 控制复选框是否可选
    const handleSelectable = function (row, index) {
      // 如果 testing 字段为 true，则禁用复选框（返回 false）
      return !row.testing;
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.multiple = !selection.length;
    };
    // 全选处理函数
    const handleSelectionAll = function (selection) {
      state.ids = selection.map(item => item.id);
      state.multiple = !selection.length;
    };
    // 排序
    const sortEvents = column => {
      state.queryParams.prop = column.prop;
      state.queryParams.order = column.order == 'ascending' ? 'asc' : 'desc';
      getList();
    };
    function getList() {
      state.loading = true;
      listPage(state.queryParams).then(res => {
        state.tableData.rows = res.data.records;
        state.tableData.total = res.data.total;
        state.loading = false;
      });
    }
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "ceshiguanli",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          icon: item.buttonIcon,
          loading: item.loadingHandle?.(item.prop, form.value),
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "icon", "loading", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.tableData,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        hasSelect: true,
        onGetList: getList,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onSelectionChange: handleSelectionChange,
        onSelectAll: handleSelectionAll,
        columnSetting: false,
        onSortEvents: sortEvents,
        selectable: handleSelectable
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])])]), _createVNode(_component_el_dialog, {
        modelValue: state.startTestDialogVisible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => state.startTestDialogVisible = $event),
        title: "开始测试",
        width: "600px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => state.startTestDialogVisible = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: state.testLoading,
          onClick: handleConfirmStartTest
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state.startTestForm,
          rules: state.startTestRules,
          ref_key: "startTestFormRef",
          ref: startTestFormRef,
          "label-width": "120px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "已选择的执行器"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectedActuatorList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: index,
                style: {
                  "margin-right": "8px",
                  "margin-bottom": "8px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.actNum) + " - " + _toDisplayString(item.valveName), 1)]),
                _: 2
              }, 1024);
            }), 128))])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "测试名称",
            prop: "taskName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: state.startTestForm.taskName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.startTestForm.taskName = $event),
              placeholder: "请输入测试名称",
              maxlength: "100"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "测试频率（分钟，5~1440）",
            prop: "taskIntervalMinutes"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: state.startTestForm.taskIntervalMinutes,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.startTestForm.taskIntervalMinutes = $event),
              min: 5,
              max: 1440,
              placeholder: "请输入测试频率",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "计划结束时间",
            prop: "planEndTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: state.startTestForm.planEndTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.startTestForm.planEndTime = $event),
              type: "datetime",
              placeholder: "计划结束时间默认为3天后",
              format: "YYYY-MM-DD HH:mm:ss",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              style: {
                "width": "100%"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remark"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: state.startTestForm.remark,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.startTestForm.remark = $event),
              type: "textarea",
              rows: 4,
              placeholder: "请输入备注",
              maxlength: "500",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: state.joinTestDialogVisible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => state.joinTestDialogVisible = $event),
        title: "加入测试",
        width: "600px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = $event => state.joinTestDialogVisible = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: state.testLoading2,
          onClick: handleConfirmJoinTest
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state.joinTestForm,
          rules: state.joinTestRules,
          ref_key: "joinTestFormRef",
          ref: joinTestFormRef,
          "label-width": "120px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "已选择的执行器"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.joinSelectedActuatorList, (item, index) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: index,
                style: {
                  "margin-right": "8px",
                  "margin-bottom": "8px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.actNum) + " - " + _toDisplayString(item.valveName), 1)]),
                _: 2
              }, 1024);
            }), 128))])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "测试任务",
            prop: "testId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: state.joinTestForm.testId,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.joinTestForm.testId = $event),
              placeholder: "请选择测试任务",
              filterable: "",
              style: {
                "width": "100%"
              },
              loading: state.testListLoading
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.testList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "loading"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};